export const createAuthRequests = (client) => ({
    login: async (attrs) => {
        const res = await client.api.request({
            url: "/auth",
            method: "POST",
            type: "user",
            body: attrs,
            params: { requestor: attrs?.requestor },
        });
        return res;
    },
    logoutUser: async () => {
        await client.api.request({
            type: "user",
            method: "DELETE",
            url: "/users/logout",
        });
    },
    resetPassword: async (attrs) => {
        const res = await client.api.request({
            url: "/auth/reset-password",
            method: "POST",
            type: "user",
            body: attrs,
            params: { requestor: attrs?.requestor },
        });
        return res;
    },
    changePassword: async (attrs) => {
        const res = await client.api.request({
            url: "/auth/change-password",
            method: "POST",
            type: "user",
            body: attrs,
            params: { requestor: attrs?.requestor },
        });
        return res;
    },
});
//# sourceMappingURL=index.js.map